import { useQueryClient, useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { shutdownAttachments } from '../../../../shared/api/queries';

const { shutdownAttachmentsKey } = shutdownAttachments;

const addAttachments = async ({ shutdownId, files }) => {
  return await Promise.allSettled(
    files.map((file) => {
      const formData = new FormData();
      formData.append('file', file);

      return request.post(
        `/Alert/attachment/${shutdownId}`,
        formData,
        `При загрузке файла ${file.name} произошла ошибка`
      );
    })
  );
};

export const useAddAttachments = () => {
  const queryClient = useQueryClient();

  const addMutation = useMutation(addAttachments, {
    onSettled: (_data, _err, { shutdownId }) =>
      queryClient.invalidateQueries(shutdownAttachmentsKey(shutdownId)),
  });

  return {
    add: addMutation.mutateAsync,
    loading: addMutation.isLoading,
  };
};
